import TipCarousel from "./TipCarousel";

const NotFound = () => {
  return <TipCarousel />;
};

export default NotFound;
